export default __webpack_public_path__ + "static/media/Nitroxgallery_71.c5dfe1d3.JPG";